import type { CSSProperties } from 'react';
import CustomFieldIconSvg from '../../assets/icons/custom_field.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const CustomFieldIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <CustomFieldIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default CustomFieldIcon;
